import { Card, Typography } from 'antd'
import { BankOutlined } from '@ant-design/icons'
import { displayMessage } from '../../../helpers/messages'
import { formatCnpj } from '../../../helpers/helper'

const { Text } = Typography

export function ReportCompanyIdentifier({ companyName, companyCnpj }) {
    if (!companyName && !companyCnpj) {
        return null
    }

    return (
        <Card
            size="small"
            className="mb-4 report-company-identifier bg-sl-gray-50 border-l-4 border-l-primary-600"
            bodyStyle={{ padding: '12px 16px' }}
        >
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
                <BankOutlined className="text-primary-600 text-lg" />
                <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
                    {companyName && (
                        <span>
                            <Text type="secondary" className="text-xs">
                                {displayMessage('CLIENT_NAME')}:{' '}
                            </Text>
                            <Text strong className="text-base">
                                {companyName}
                            </Text>
                        </span>
                    )}
                    {companyCnpj && (
                        <span>
                            <Text type="secondary" className="text-xs">
                                {displayMessage('COMPANY_DOCUMENT')}:{' '}
                            </Text>
                            <Text>{formatCnpj(companyCnpj)}</Text>
                        </span>
                    )}
                </div>
            </div>
        </Card>
    )
}
